import React, { Component, PropTypes } from 'react';
import { autobind } from 'core-decorators';

import InputWrapper from 'AppComponents/Forms/InputWrapper';
import FormGroup from 'AppComponents/Forms/FormGroup';
import Star from 'AppComponents/Star';

import '../Rating/styles.scss';


class RatingInput extends Component {

  static propTypes = {
    children: PropTypes.node,
    disabled: PropTypes.bool,
    formsy: PropTypes.shape({
      setValue: PropTypes.func,
    }),
    onChange: PropTypes.func,
    renderFeedback: PropTypes.func,
    value: PropTypes.number,
  };

  static defaultProps = {
    children: null,
    disabled: false,
    formsy: {},
    onChange: null,
    renderFeedback: null,
    value: null,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      hovered: 0,
    };
  }

  onStarHover(number) {
    if (!this.props.disabled) this.setState({ hovered: number });
  }

  onStarClick(number) {
    const { formsy, onChange } = this.props;
    const { setValue } = formsy;
    if (!this.props.disabled) {
      if (setValue) setValue(number);
      if (onChange) onChange(number);
    }
  }

  @autobind
  onMouseOut() {
    if (!this.props.disabled) this.setState({ hovered: 0 });
  }

  render() {
    const { value, renderFeedback } = this.props;
    const stars = [];
    for (let i = 1; i <= 5; i += 1) {
      stars.push(
        <Star
          number={i}
          filled={i <= value}
          hovered={i <= this.state.hovered}
          key={i}
          onMouseOver={() => this.onStarHover(i)}
          onClick={() => this.onStarClick(i)}
          styleName='star'
        />,
      );
    }

    return (
      <div>

        <ol className='rating stars' styleName='rating' onMouseOut={this.onMouseOut}>
          { stars }
        </ol>

        { renderFeedback && renderFeedback() }

        { this.props.children }

      </div>
    );
  }
}

export default InputWrapper(RatingInput, FormGroup);



// WEBPACK FOOTER //
// ./app/scripts/views/App/components/RatingInput/index.jsx